import { StakedPositionRow } from "./StakedPositionRow";
import { StakedPositionSkeletonRow } from "./StakedPositionSkeletonRow";
import { useStakedPositionsTable } from "./useStakedPositionsTable";
import { memo } from "react";
import { PortfolioPositionsTable } from "../PortfolioPositionsTable";

export const StakedPositionsTable = memo(() => {
    const { isLoading, table, rowModel } = useStakedPositionsTable();

    return (
        <PortfolioPositionsTable
            positionType="staked"
            isLoading={isLoading}
            table={table}
            rowModel={rowModel}
            renderRow={(row, menuProps) => (
                <StakedPositionRow
                    key={row.id}
                    position={row.original}
                    index={row.index}
                    isMenuOpen={menuProps.isMenuOpen}
                    menuIndex={menuProps.menuIndex}
                    onMenuToggle={menuProps.onMenuToggle}
                />
            )}
            renderSkeletonRow={(index) => <StakedPositionSkeletonRow key={index} />}
        />
    );
});

StakedPositionsTable.displayName = "StakedPositionsTable";
